import { render, staticRenderFns } from "./DwTotalActiveByState.vue?vue&type=template&id=b98e69d0&"
import script from "./DwTotalActiveByState.vue?vue&type=script&lang=js&"
export * from "./DwTotalActiveByState.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports